/* eslint-disable no-restricted-syntax */
/**
 * Class for dealing with state name conversions
 */
class MembershipNames {
  /**
   * Builds an object containing `state abbreviation : state` relationships to be used in other places
   *
   * @return an object containing `state abbreviation: state` relationships
   */
  getStateNames(): Record<string, string> {
    const states = {
      can: 'Canada',
      al: 'Alabama',
      ak: 'Alaska',
      az: 'Arizona',
      ar: 'Arkansas',
      ca: 'California',
      co: 'Colorado',
      ct: 'Connecticut',
      de: 'Delaware',
      fl: 'Florida',
      ga: 'Georgia',
      hi: 'Hawaii',
      id: 'Idaho',
      il: 'Illinois',
      in: 'Indiana',
      ia: 'Iowa',
      ks: 'Kansas',
      ky: 'Kentucky',
      la: 'Louisiana',
      me: 'Maine',
      md: 'Maryland',
      ma: 'Massachusetts',
      mi: 'Michigan',
      mn: 'Minnesota',
      ms: 'Mississippi',
      mo: 'Missouri',
      mt: 'Montana',
      ne: 'Nebraska',
      nv: 'Nevada',
      nh: 'New Hampshire',
      nj: 'New Jersey',
      nm: 'New Mexico',
      ny: 'New York',
      nc: 'North Carolina',
      nd: 'North Dakota',
      oh: 'Ohio',
      ok: 'Oklahoma',
      or: 'Oregon',
      pa: 'Pennsylvania',
      ri: 'Rhode Island',
      sc: 'South Carolina',
      sd: 'South Dakota',
      tn: 'Tennessee',
      tx: 'Texas',
      ut: 'Utah',
      vt: 'Vermont',
      va: 'Virginia',
      wa: 'Washington',
      wv: 'West Virginia',
      wi: 'Wisconsin',
      wy: 'Wyoming',
    }

    return states
  }

  /**
   * Builds an object containing `region abbreviation : region` relationships to be used in other places
   *
   * @return an object containing `region abbreviation: region` relationships
   */
  getRegionNames(): Record<string, string> {
    return {
      can: 'Canada',
    }
  }

  /**
   * This function accepts a state abbreviation (MT, ID, etc.) and returns the full state name
   *
   * @param input - the state abbreviation to convert
   * @return fullStates[abbv] - the value of fullStates[] where the key is equal to the state abbreviation passed in
   */
  convertStateAbbvToName(input: string): string | undefined {
    const abbv = input.toLowerCase()
    const fullStates = this.getStateNames()

    return fullStates[abbv]
  }
}

const membershipNames = new MembershipNames()
export default membershipNames
